import * as Yup from 'yup';

export const updateToolValidationSchema = Yup.object().shape({
  reason: Yup.string()
    .required('Reason is required')
    .min(3, 'Reason must be at least 3 characters'),
  monitoringOption: Yup.string()
    .required('Monitoring option is required')
    .oneOf(['Always', 'Sometimes', 'Never'], 'Invalid monitoring option'),
  linkedProducts: Yup.array().of(
    Yup.object().shape({
      id: Yup.string().required(),
      name: Yup.string().required('Product name is required'),
    })
  ),
  productLicenses: Yup.array().of(
    Yup.object().shape({
      id: Yup.string().required(),
      name: Yup.string().required('License name is required'),
      quantity: Yup.number()
        .required('Quantity is required')
        .min(0, 'Quantity cannot be negative'),
      pricePerUnit: Yup.string().required('Price is required'),
    })
  ),
});
